<template>
  <div class="hello" @click="(isShowSelect = false), (isShowMoney = false)">
    <div class="header">
      <div class="top">
        <a href="/" class="logo"></a>
        <img class="logo_game" src="../assets/logo_game.jpg" alt="" />
        <ul class="nav">
          <li><a @click="$router.push('/')">平台首页</a></li>
          <li><a @click="$router.push('/about')">关于我们</a></li>
          <li><a @click="$router.push('/game')">开始游戏</a></li>
          <li class="active"><a @click="$router.push('/pay')">支付</a></li>
        </ul>
      </div>
    </div>
    <div class="pay-banner"></div>
    <div class="pay-w e_pay_wrap">
      <div class="clearfix pay-main">
        <div class="clearfix pay-main-w">
          <div class="fl pay-mode e_pay_mode">
            <ul class="clearfix pay-mode-main">
              <li
                class="fl"
                v-for="(item, index) in pay_name_list"
                :key="index"
              >
                <a
                  :class="[
                    pay_active == item.id
                      ? 'block pay-public cur'
                      : 'block pay-public',
                  ]"
                  @click="handleClickPayType(item.id)"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <div class="pay-content e_pay_content">
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >可售卖游戏：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowSelect ? 'cur' : '']"
                >
                  <span v-on:click.stop="arrowDown" class="pay-select-arrow"
                    >&#9660;</span
                  >
                  <input
                    v-on:click.stop="arrowDown"
                    type="text"
                    class="pay-select-selected e_selected"
                    readonly="readonly"
                    :value="unitName"
                    sucmsg="&nbsp;"
                  />
                  <div
                    class="clearfix pay-select-options-w hide e_options"
                    v-show="isShowSelect"
                  >
                    <h2 class="pay-select-options">
                      <a
                        class="fl"
                        :class="[index == 0 ? 'first' : '']"
                        v-for="(item, index) in productInfo"
                        @click.stop="select(item.product, index)"
                        :key="index"
                      >
                        {{ item.product }}
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >输入账号：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowSelect ? 'cur' : '']"
                >
                  <input
                    type="text"
                    class="pay-select-selected e_selected"
                    :v-model="account"
                    sucmsg="&nbsp;"
                  />
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >购买商品：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowMoney ? 'cur' : '']"
                >
                  <span class="pay-select-arrow" v-on:click.stop="arrowMoney"
                    >&#9660;</span
                  >
                  <input
                    v-on:click.stop="arrowMoney"
                    type="text"
                    class="pay-select-selected e_selected"
                    readonly="readonly"
                    :value="
                      unitMoney == ''
                        ? '请选择商品'
                        : unitMoney.num + '钻石(人民币' + unitMoney.money + '元)'
                    "
                    sucmsg="&nbsp;"
                  />
                  <div
                    class="clearfix pay-select-options-w hide e_options"
                    v-show="isShowMoney"
                  >
                    <h2 class="pay-select-options">
                      <a
                        class="fl"
                        :class="[item_money == 0 ? 'first' : '']"
                        v-for="(item_money, index_money) in money_list"
                        @click.stop="select_money(item_money)"
                        :key="index_money"
                      >
                        {{ item_money.num }}钻石(人民币{{ item_money.money }}元)
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >充值金额：</label
              >
              <span
                style="line-height: 38px; font-size: 20px; font-weight: bold"
              >
                {{ !unitMoney.money  ? "0" : unitMoney.money }} 元</span
              >
            </div>
            <div style="display: flex">
              <label class="pay-title" style="line-height: 38px" /><input
                type="submit"
                class="block pay-submit e_submit"
                style="width: 120px"
                value="确定充值"
                @click="handleOpenText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <div class="fl">
          <a href=""
            ><img style="width: 200px" src="../assets/logo.png" alt=""
          /></a>
        </div>
        <div class="fr">
          <p>
            健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
            适度游戏益脑 沉迷游戏伤身 合理安排 时间享受健康生活
          </p>
          <p>
            ICP 备案号：<a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              > 粤ICP备2022029305号</a
            >
          </p>
          <p>公司名称：广州龙猫数据网络科技有限公司</p>
          <p>
            公司地址：广州市天河区棠下荷光三横路13号406房
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pay",
  data() {
    return {
      isShowSelect: false,
      isShowMoney: false,
      unitName: "请选择游戏",
      unitMoney: "",
      pay_active: 1,
      account: "",
      pay_name_list: [
        // {
        //   id: 1,
        //   name: '银行卡充值'
        // },
        //{
        // id: 1,
        //  name: '支付宝扫码充值'
        //  },
        // {
        //  id: 2,
        //   name: '微信扫码充值'
        //  },
        {
          id: 3,
          name: "支付宝充值",
        },
        {
          id: 4,
          name: "微信充值",
        },
      ],
      money_list: [
        { num: 80, money: 0.3 },
        { num: 500, money: 1.5 },
        { num: 1200, money: 3.4 },
        { num: 2500, money: 6.4 },
        { num: 6500, money: 16.4 },
        { num: 14000, money: 32.4 },
      ],
      productInfo: [
        //   {
        //   pid: 'p-p7',
        //   product: '琴剑封魔录',
        //   phone: '021-61174567',
        //   email: 'tzjkefu@iwgame.com',
        //   url: 'http://tzj2.iwgame.com/',
        //   murl: 'http://tzj2.iwgame.com/',
        //   downUrl: 'http://tzj2.iwgame.com/',
        //   logo: 'http://tzj2.iwgame.com/images/v3/common/logo.png',
        //   carousel: 'https://www.iwgame.com/js/poster_js/209.js',
        //   productPosterJs: 'https://www.iwgame.com/js/poster_js/210.js',
        //   passportLoginBgJs: 'https://www.iwgame.com/js/poster_js/211.js'
        // },
        //  {
        //   pid: 'p-p1',
        //   product: '异兽擎天',
        //   phone: '021-61174567',
        //   email: 'kefu@shumenol.com',
        //   url: 'http://www.shumenol.com/',
        //   murl: 'http://m.shumenol.com/',
        //   downUrl: 'http://www.shumenol.com/html/download/'
        // },
        {
          pid: "p-p1.5",
          product: "守护者之森",
          phone: "021-61174567",
          email: "kf@zuixiaoyao.com",
          url: "http://www.zuixiaoyao.com/",
          murl: "http://m.zuixiaoyao.com/",
          downUrl: "http://www.zuixiaoyao.com/download.htm",
        },
      ],
    };
  },
  methods: {
    handleClickPayType(id) {
      this.pay_active = id;
    },
    arrowDown() {
      this.isShowSelect = !this.isShowSelect;
    },
    arrowMoney() {
      this.isShowMoney = !this.isShowMoney;
    },
    select(name) {
      this.isShowSelect = false;
      this.unitName = name;
    },
    select_money(name) {
      this.isShowMoney = false;
      this.unitMoney = name;
    },
    handleOpenText() {
      window.alert("敬请期待！");
    },
  },
};
</script>
<style scoped>
.dropdown-content {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.6s ease-in-out;
}

.dropdown-menu {
  margin-top: 4px;
  padding: 10px 8px 15px;
  color: white;
  background-color: #000;
  border-radius: 4px;
}

.menuItem {
  width: 100%;
  white-space: nowrap;
  padding: 10px 16px;
  font-size: 16px;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.menuItem :hover {
  background-color: #ccc;
}

ul,
li {
  list-style: none;
}

.logo_game {
  height: 50%;
  position: relative;
  top: 39%;
  left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue